import cn from "@utils/cn";
import { getIconProps } from "@utils";
import Icon from "@elements/Icon";
import { useOperation } from "@hooks";

const CLASS_NAMES = cn(`
  flex
  items-center
  gap-3
  px-5
  py-3
  cursor-pointer

  hover:bg-black/20

  active:bg-black/30
`);

const LABEL_CLASS_NAMES = cn(`
  text-base
  font-medium
  select-none

  text-(--navbar-foreground-color)
`);

export default function DrawerOperationItem(props) {
  const {
    label,
    operation,
    closeDrawer,
    isAdminOnly,
  } = props;

  const {
    text,
    icon,
  } = label;

  const iconProps = getIconProps(icon, {
    fixedWidth: true,
    color: "white",
  });

  const enqueueOperation = useOperation({
    key: operation.key,
    args: operation.args,
    callback: operation.callback,
    enqueueDelay: operation.enqueueDelay,
  });

  const handleClick = () => {
    if (window.confirm(`Are you sure you want to execute: ${text}?`)) {
      closeDrawer(false);
      enqueueOperation();
    }
  };

  return (
    <div
      className={CLASS_NAMES}
      onClick={handleClick}
    >
      {icon && (
        <Icon {...iconProps} />
      )}

      <span className={LABEL_CLASS_NAMES}>
        {text}
        {isAdminOnly ? "*" : ""}
      </span>
    </div>
  );
}
